import HeaderContent from "../header_content";
import CognitoController from "../../../common/scripts/cognito_controller";
import VueStore from "../../../store/VueStore";

const switchWait = (self: HeaderContent) => {
  self.submitHeaderButton = false;
  self.submitHeaderWait = true;
};

const switchSuccess = (self: HeaderContent) => {
  self.submitHeaderWait = false;
  self.submitHeaderComplete = true;
};

export async function saveUserSetting(self: HeaderContent) {
  switchWait(self);

  const cognitoController = new CognitoController();
  const useSignal: boolean = self.useSignal;
  const usePresence: boolean = self.usePresence;
  const useTimeZone: string = self.timeZone;
  cognitoController.setUseSignal(useSignal);
  cognitoController.setUsePresence(usePresence);
  cognitoController.setUseTimeZone(useTimeZone);

  await cognitoController.update();

  switchSuccess(self);
  VueStore.commit("setUseSignal", useSignal);
  VueStore.commit("setUsePresence", usePresence);
  VueStore.commit("setUseTimeZone", useTimeZone);
  self.useSignal = useSignal;
  self.useSignal = usePresence;
  self.timeZone = useTimeZone;
  location.reload();
}
